import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE } from 'ducks/slice';
import { User } from 'ducks/user/types';
import { jwtDecode } from 'jwt-decode';
import { removeLocalStorage, setLocalStorage } from 'utils/storage';

const initialState: User = {
  token: '',
  email: '',
  email_verified: false,
  exp: 0,
  first_name: '',
  iat: 0,
  is_admin: false,
  is_guest: false,
  is_staff: false,
  is_system: false,
  last_name: '',
  two_factor: false,
  two_factor_expiration_date: null,
  user_id: 0,
  user_name: '',
};

export const userSlice = createSlice({
  name: SLICE.USER,
  initialState,
  reducers: {
    setToken: (_state, action: PayloadAction<Pick<User, 'token'>>) => {
      const { token } = action.payload;
      const decoded = jwtDecode(token);
      const user = { token, ...decoded };
      setLocalStorage('user', user);
      return user as User;
    },
    setUser: (_state, action) => {
      return action.payload;
    },
    clearUser: () => {
      removeLocalStorage('user');
      return initialState;
    },
  },
});

export const { clearUser, setUser, setToken } = userSlice.actions;

export default userSlice.reducer;
